import { render, staticRenderFns } from "./EditarMontoBuro.vue?vue&type=template&id=29c162fe&scoped=true&"
import script from "./EditarMontoBuro.vue?vue&type=script&lang=js&"
export * from "./EditarMontoBuro.vue?vue&type=script&lang=js&"
import style0 from "./EditarMontoBuro.vue?vue&type=style&index=0&id=29c162fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c162fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSlider})
